import veritoneApi from './veritoneApi';

//load all folder and advertiser
export function loadApi(urlApi) {
    return veritoneApi(urlApi.baseUrl)
        .get(urlApi.listFolder)
        .then(response => {
            if (response.data) {
                return response.data.results;
            }
            return [];
        })
        .catch(error => [])
}

export function updateFolderApi(urlApi, folder) {
    return veritoneApi(urlApi.baseUrl)
        .put(
            `folder/${folder.folder_id}`,
            {
                "folder_name": folder.folder_name,
                "organization_id": folder.organization_id,
                "folder_watchlist_id": folder.folder_watchlist_id
            })
        .then(response => response.data.folder)
        .catch(error => ({
            error: true,
            ...error
        }))
}

//api new folder 
export function addFolderApi(urlApi, folder) {
    return veritoneApi(urlApi.baseUrl)
        .post(
            `${urlApi.folder}`,
            { folder_name: folder }
        )
        .then(response => response.data.folder)
        .catch(error => ({
            error: true,
            ...error
        }))
}

//api list folder - only folder

export function getListFolderApi(urlApi) {
    return veritoneApi(urlApi.baseUrl)
        .get(
            `${urlApi.folder}`
        )
        .then(response => response.data.results)
        .catch(error => ({
            error: true,
            ...error
        }))
}


export function deleteFolderApi(urlApi, id) {
    return veritoneApi(urlApi.baseUrl)
        .delete(
            `${urlApi.folder}/${id}`,
        )
        .then(response => response)
        .catch(error => ({
            error: true,
            ...error
        }))
}

export function getDetailFolderApi(urlApi, folder) {
    return veritoneApi(urlApi.baseUrl)
        .get(`${urlApi.folder}/${folder.folder_id}`)
        .then(response => response.data.results)
        .catch(error => ({
            error: true,
            ...error
        }))
}